export const SET_REGISTERED = 'SET_REGISTERED';

export const setRegistered = (registered) => ({
	type: SET_REGISTERED,
	registered,
});
